import { render, staticRenderFns } from "./ProfileButton.vue?vue&type=template&id=7e3de32a&scoped=true"
import script from "./ProfileButton.vue?vue&type=script&lang=js"
export * from "./ProfileButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3de32a",
  null
  
)

export default component.exports